/**
 * =============================================================================
 *
 * @format
 */

/*===============================  IMPORTS  ===================================*/
/*=============================================================================*/
import Customize_Reworked from "./index";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { ClipboardList } from "lucide-react";
import { motion } from "framer-motion";

const SummaryItem = ({ label, value }) => (
	<div className="flex flex-col md:flex-row md:items-center py-3 border-b border-gray-100 last:border-none">
		<dt className="font-bold w-full md:w-1/3">{label}</dt>
		<dd className="font-medium md:w-2/3">{value || "-"}</dd>
	</div>
);

const Customize_Summary = () => {
	/*=============================================================================*/
	/*===============================  VARIABLES  =================================*/
	/*=============================================================================*/
	var { productInfo, optionInfo } = useSelector(
		(state) => state.customize.customizeProduct
	);

	const BottomBar = productInfo?.Bottom_Bar;

	const displayBottomBar = getHemTypeDisplayName(BottomBar);

	const driveName = productInfo?.Operation;
	function getDriveTypeDisplayName(item) {
		if (item === "Zero Gravity") {
			return "Chainless Manual";
		} else if (item === "Chain") {
			return "Chain Manual";
		} else if (item === "Motor") {
			return "Automated";
		} else {
			return item;
		}
	}

	const displayDrive = getDriveTypeDisplayName(driveName);

	const valanceName = productInfo?.Valance;
	function getValanceTypeDisplayName(valanceName) {
		switch (valanceName) {
			case "Zero Gravity":
				return "Glide Chainless";
			case 'SB 3" Fascia':
				return '3" Fascia';
			case "SB Compact Curved Cassette":
				return "Compact Curved Cassette";
			case 'SB 4" Fascia':
				return '4" Fascia';
			case "SB Curved Cassette":
				return "Curved Cassette";
			default:
				return valanceName;
		}
	}

	function getHemTypeDisplayName(BottomBar) {
		if (BottomBar === "Accubar 2.1") {
			return "Aluminum Hem";
		} else if (BottomBar === "Interlude 2.0") {
			return "Aluminum Bar";
		} else if (BottomBar === "Illusion") {
			return "Aluminum Bar";
		} else {
			return BottomBar;
		}
	}

	const displayValance = getValanceTypeDisplayName(valanceName);

	const displayFractionOrEmpty = (fraction) => {
		return fraction === "0/16" ? "" : fraction;
	};

	const summaryData = [
		{
			label: "Shade Type",
			value: productInfo?.Program,
		},
		{
			label: "Size",
			value: `${optionInfo?.widthWhole} ${displayFractionOrEmpty(
				optionInfo?.widthFraction
			)} x ${optionInfo?.lengthWhole} ${displayFractionOrEmpty(
				optionInfo?.lengthFraction
			)}`,
		},
		{
			label: "Type",
			value: productInfo?.Type,
		},
		{
			label: "Drive",
			value: displayDrive,
		},
		...(productInfo?.Operation === "Motor"
			? [
					{
						label: "Remote",
						value: productInfo?.remote,
					},
					{
						label: "Charger",
						value: productInfo?.charger,
					},
					{
						label: "Connector",
						value: productInfo?.connector,
					},
			  ]
			: []),
		{
			label: "Drive Position",
			value: productInfo?.position,
		},
		{
			label: "Fabric",
			value: productInfo?.OCS_Name,
		},
		{
			label: "Fabric Color",
			value:
				productInfo?.OCS_Colour === ""
					? optionInfo?.selectedColor
					: productInfo?.OCS_Colour,
		},
		{
			label: "Valance",
			value: displayValance,
		},
		{
			label: "Valance Color",
			value: productInfo?.Valance_Color,
		},
		{
			label: "Bottom Bar",
			value: displayBottomBar,
		},
		{
			label: "Bottom Bar Color",
			value: productInfo?.Bottom_Bar_Color,
		},
		// {
		// 	label: "L Channel",
		// 	value: productInfo?.L_Channel,
		// },
	];

	/*=============================================================================*/
	/*===============================  RENDER  ====================================*/
	/*=============================================================================*/

	return (
		<Customize_Reworked>
			<div className="space-y-8">
				{/* Header */}
				<div className="flex items-center gap-3">
					<div className="w-10 h-10 bg-primary/10 rounded-xl flex items-center justify-center">
						<ClipboardList className="w-6 h-6 text-primary" />
					</div>
					<h3 className="text-lg font-medium">Order Summary</h3>
				</div>

				{/* Summary Card */}
				<motion.div
					initial={{ opacity: 0, y: 20 }}
					animate={{ opacity: 1, y: 0 }}
					className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6"
				>
					<dl className="divide-y divide-gray-100">
						{summaryData.map((item, index) => (
							<SummaryItem key={index} label={item.label} value={item.value} />
						))}
					</dl>
				</motion.div>
			</div>
		</Customize_Reworked>
	);
};

export default Customize_Summary;
